import { useMap } from 'react-leaflet';
import { useEffect } from 'react';
import L from 'leaflet';
const Bounds = ({ userLocation, targetLocation, forceFitBounds }) => {
    const map = useMap();
    useEffect(() => {
        if (!userLocation) {
            return;
        }
        const bounds = L.latLngBounds([
            [userLocation.lat, userLocation.lng],
            [targetLocation.lat, targetLocation.lng],
        ]);
        if (forceFitBounds) {
            map.fitBounds(bounds, { padding: [25, 25] });
        }
    }, [userLocation, targetLocation, forceFitBounds, map]);
    return null;
};
export default Bounds;
